<template>
  <div>
    <div>
      <el-form v-loading.fullscreen.lock="fullscreenLoading" :inline="true">
        <el-form-item size="mini" label="姓名:">
          <el-input
            clearable
            v-model="selectform.name"
            placeholder="输入姓名"
            style="width: 100px"
            size="mini"
          ></el-input>
        </el-form-item>
        <el-form-item size="mini" label="身份证:">
          <el-input
            clearable
            v-model="selectform.idcard"
            placeholder="输入身份证"
            style="width: 165px"
            size="mini"
          ></el-input>
        </el-form-item>
        <el-form-item size="mini" label="机构:">
          <el-select
            @change="getdata"
            style="width: 130px"
            clearable
            v-model="selectform.hosp"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in hosps"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item size="mini" label="状态">
          <el-select
            @change="getdata"
            style="width: 130px"
            clearable
            v-model="selectform.status"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in allstatus"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="org.area == '371100000000'"
          size="mini"
          label="地区"
        >
          <el-select
            style="width: 160px"
            clearable
            v-model="selectform.qu_id"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in optionss"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item size="mini" label="年份">
          <el-date-picker
            style="width: 10vw; font-size: 103%"
            v-model="nian"
            type="year"
            placeholder="年度切换"
          >
          </el-date-picker>
        </el-form-item>
        <el-button-group>
          <el-button @click="getdata" type="primary" size="mini"
            >查询</el-button
          >
          <el-button @click="clear" size="mini" type="primary" plain
            >清空</el-button
          >
        </el-button-group>
        <el-button-group style="margin-left: 5px">
          <el-button
            icon="el-icon-upload2"
            @click="dialogVisible = true"
            type="success"
            size="mini"
            >导入</el-button
          >
          <el-button
            icon="el-icon-download"
            @click="clear"
            size="mini"
            type="success"
            plain
            >导出</el-button
          >
        </el-button-group>
      </el-form>
    </div>
    <el-table
      height="calc(100vh - 220px)"
      size="mini"
      :data="lists"
      border
      style="width: 94%"
    >
      <el-table-column type="index" label="序号" width="50"> </el-table-column>
      <el-table-column prop="name" label="姓名"> </el-table-column>
      <el-table-column prop="idcard" label="身份证号"> </el-table-column>
      <el-table-column prop="jh_name" label="家长姓名"> </el-table-column>
      <el-table-column prop="hosp" label="所在机构"> </el-table-column>
      <el-table-column label="残疾类型">
        <template slot-scope="scope">
          <el-tag
            style="margin-left: 2px; margin-right: 2px"
            v-for="(p, i) in scope.row.cjtypes"
            :key="i"
            size="mini"
            >{{ p }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        label="状态"
        style="display: flex; justify-content: center"
      >
        <template slot-scope="scope">
          <el-tag size="medium" :type="scope.row.status.color">{{
            scope.row.status.name
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button @click="showdetail(scope.row)" type="text" size="small"
            >详情</el-button
          >
          <el-button
            v-if="false"
            @click="godangan(scope.row)"
            type="text"
            size="small"
            >档案</el-button
          >
          <el-popover
            style="margin-left: 10px; margin-right: 10px"
            placement="top"
            width="160"
            v-model="scope.row.guidang"
          >
            <div style="margin: 0">
              <el-button
                @click="changestatus(scope.row, 0, '转介')"
                size="mini"
                type="success"
                >重新转介
              </el-button>
              <el-button
                @click="changestatus(scope.row, -1, '不在训')"
                size="mini"
                type="primary"
                >不在训
              </el-button>
            </div>
            <el-button slot="reference" type="text" size="small"
              >操作</el-button
            >
          </el-popover>
          <el-button
            @click="changestatus(scope.row, -2, '删除')"
            type="text"
            style="color: red"
            size="small"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top: 5px"
      :page-size="20"
      @current-change="getdata"
      :current-page.sync="page"
      :total="total"
      layout="total,prev, pager, next"
      background
    >
    </el-pagination>
    <el-dialog
      title="上传康复儿童数据"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
    >
      <div
        style="
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
        "
      >
        <div style="width: 360px; margin-bottom: 10px">
          <div>下载导入模板。</div>
          <div style="font-size: 90%; color: red">
            **导入后不在线上名单的儿童会自动写入并转介给机构
          </div>
        </div>
        <el-upload
          class="upload-demo"
          drag
          action="http://localhost:3001/upload"
          :multiple="false"
          :on-success="test"
          :on-error="test"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传xlsx文件</div>
        </el-upload>
      </div>
    </el-dialog>
    <el-dialog
      :title="biao.name + '的康复救助情况'"
      :visible.sync="detailflag"
      width="80%"
    >
      <el-descriptions
        size="mini"
        class="margin-top"
        title="基本信息"
        border
        v-if="biao.name"
      >
        <template v-if="false" slot="extra">
          <el-button type="primary" size="small">下载申请表</el-button>
        </template>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-user"></i>
            办理人姓名
          </template>
          {{ biao.name }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-postcard"></i>
            身份证号
          </template>
          {{ biao.idcard }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-mobile-phone"></i>
            手机号
          </template>
          {{ biao.phone ? biao.phone : detail.phone }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-location-outline"></i>
            户籍地
          </template>
          <span v-for="(p, i) in biao.huji_json" :key="i"> {{ p.name }}</span>
          <span>{{ biao.huji_address }}</span>
        </el-descriptions-item>
        <el-descriptions-item
          v-if="biao.xianju_json && biao.xianju_json.length > 0"
        >
          <template slot="label">
            <i class="el-icon-office-building"></i>
            现居地
          </template>
          <div v-if="biao.xianju_json == ''">
            <span v-for="(p, i) in biao.huji_json" :key="i"> {{ p.name }}</span>
            <span>{{ biao.huji_address }}</span>
          </div>
          <div v-else>
            <span v-for="(p, i) in biao.xianju_json" :key="i">
              {{ p.name }}</span
            >
            <span>{{ biao.xianju_address }}</span>
          </div>
        </el-descriptions-item>
        <el-descriptions-item v-if="biao.jh_name">
          <template slot="label">
            <i class="el-icon-user"></i>
            监护人姓名
          </template>
          {{ biao.jh_name }}
        </el-descriptions-item>
        <el-descriptions-item v-if="biao.jh_idcard">
          <template slot="label">
            <i class="el-icon-user"></i>
            监护人身份证
          </template>
          {{ biao.jh_idcard }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-date"></i>
            申请时间
          </template>
          {{ biao.ins_date }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 来自 </template>
          {{ biao.from }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 所在机构 </template>
          {{ biao.hosp }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 状态 </template>
          <el-tag size="medium" :type="biao.status.color">{{
            biao.status.name
          }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 残疾类型 </template>
          <span
            style="margin-left: 5px; margin-right: 5px"
            v-for="(p, i) in biao.cjtypes"
            :key="i"
            >{{ p }}</span
          >
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 康复类型 </template>
          {{ biao.type }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 银行卡号 </template>
          {{ biao.yhcard }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 医保类型 </template>
          {{ biao.yibao }}
        </el-descriptions-item>
        <el-descriptions-item v-if="biao.yixuezhengming">
          <template slot="label"> 诊断证明 </template>
          <div v-if="biao.yixuezhengming">
            <el-image
              :preview-src-list="[$url + item.path]"
              fit="scale-down"
              style="width: 200px"
              v-for="(item, index) in biao.yixuezhengming"
              :key="index"
              :src="$url + item.path"
            >
              <div slot="placeholder" class="image-slot">
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
          </div>
        </el-descriptions-item>
      </el-descriptions>
      <div>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div class="el-descriptions__title margin-top">打卡记录</div>
          <div style="font-size: 16px">月打卡：{{ day_sum }}天</div>
          <div style="font-size: 16px">
            月考勤时长：{{ shichang_sum.toFixed(2) }}小时
          </div>
          <div>
            <el-button @click="opdang" v-if="isdang" type="text" size="small"
              >查看儿童档案</el-button
            >
            <el-button @click="opdangkq" type="text" size="small"
              >查看全年考勤</el-button
            >
          </div>
        </div>

        <div v-if="isdang" v-loading="loading">
          <el-calendar ref="calendar" v-model="nianv1" v-prev-month-btn>
            <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
            <template slot="dateCell" slot-scope="{ date, data }">
              <div
                style="
                  width: 100%;
                  height: 100%;
                  display: flex;
                  flex-direction: column;
                "
                v-if="
                  riLists.findIndex((x) => {
                    return x.day == data.day;
                  }) >= 0 &&
                  riLists.find((x) => {
                    return x.day == data.day;
                  }).bq_reason == '' &&
                  riLists.find((x) => {
                    return x.day == data.day;
                  }).riqi_lj_text == ''
                "
              >
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    开始时间:{{
                      riLists.find((x) => x.day == data.day && x.isclock)
                        .time_star
                    }}--结束时间:{{
                      riLists.find((x) => x.day == data.day && x.isclock)
                        .time_end
                    }}
                    总时长：{{
                      riLists.find((x) => x.day == data.day && x.isclock)
                        .time_sum
                    }}
                  </div>
                  <div>
                    <p style="margin-bottom: 0px; padding-bottom: 0px">
                      {{ data.day.split("-").slice(1).join("-") }}
                      <span
                        v-if="
                          riLists.findIndex((x) => {
                            return x.day == data.day;
                          }) >= 0
                        "
                        style="color: green"
                        >✔</span
                      >
                      ️
                    </p>
                    <p
                      style="
                        margin-top: 10px;
                        padding-top: 0px;
                        color: green;
                        font-size: 80%;
                      "
                      v-if="
                        riLists.findIndex((x) => {
                          return x.day == data.day && x.isclock;
                        }) >= 0
                      "
                    >
                      {{
                        riLists.find((x) => x.day == data.day && x.isclock).type
                      }}
                      <span style="color: red">
                        {{
                          riLists.find((x) => x.day == data.day && x.isclock)
                            .riqi_bu ==
                          riLists.find((x) => x.day == data.day && x.isclock)
                            .riqi_ke
                            ? ""
                            : riLists.find(
                                (x) => x.day == data.day && x.isclock
                              ).riqi_bu
                        }}
                      </span>
                    </p>
                  </div>
                </el-tooltip>
              </div>

              <div
                style="
                  width: 100%;
                  height: 100%;
                  display: flex;
                  flex-direction: column;
                "
                v-else
              >
                <el-tooltip
                  placement="top"
                  effect="light"
                  v-if="
                    riLists.findIndex((x) => {
                      return x.day == data.day;
                    }) >= 0
                  "
                >
                  <div slot="content">
                    {{
                      riLists.find((x) => {
                        return x.day == data.day;
                      }).bq_reason
                    }}<br />
                    {{
                      riLists.find((x) => {
                        return x.day == data.day;
                      }).riqi_lj_text
                    }}
                  </div>
                  <div>
                    <p style="margin-bottom: 0px; padding-bottom: 0px">
                      {{ data.day.split("-").slice(1).join("-") }}
                      <span
                        v-if="
                          riLists.findIndex((x) => {
                            return x.day == data.day;
                          }) >= 0
                        "
                        style="color: green"
                        >✔</span
                      >
                      ️
                    </p>
                    <p
                      style="
                        margin-top: 10px;
                        padding-top: 0px;
                        color: green;
                        font-size: 80%;
                      "
                      v-if="
                        riLists.findIndex((x) => {
                          return x.day == data.day && x.isclock;
                        }) >= 0
                      "
                    >
                      {{
                        riLists.find((x) => x.day == data.day && x.isclock).type
                      }}
                      <span style="color: red">
                        {{
                          riLists.find((x) => x.day == data.day && x.isclock)
                            .riqi_bu ==
                          riLists.find((x) => x.day == data.day && x.isclock)
                            .riqi_ke
                            ? ""
                            : riLists.find(
                                (x) => x.day == data.day && x.isclock
                              ).riqi_bu
                        }}
                      </span>
                    </p>
                  </div>
                </el-tooltip>
                <div v-else>
                  <p style="margin-bottom: 0px; padding-bottom: 0px">
                    {{ data.day.split("-").slice(1).join("-") }}
                    <span
                      v-if="
                        riLists.findIndex((x) => {
                          return x.day == data.day;
                        }) >= 0
                      "
                      style="color: green"
                      >✔</span
                    >
                    ️
                  </p>
                  <p
                    style="
                      margin-top: 10px;
                      padding-top: 0px;
                      color: green;
                      font-size: 80%;
                    "
                    v-if="
                      riLists.findIndex((x) => {
                        return x.day == data.day && x.isclock;
                      }) >= 0
                    "
                  >
                    {{
                      riLists.find((x) => x.day == data.day && x.isclock).type
                    }}
                    <span style="color: red">
                      {{
                        riLists.find((x) => x.day == data.day && x.isclock)
                          .riqi_bu ==
                        riLists.find((x) => x.day == data.day && x.isclock)
                          .riqi_ke
                          ? ""
                          : riLists.find((x) => x.day == data.day && x.isclock)
                              .riqi_bu
                      }}
                    </span>
                  </p>
                </div>
              </div>
            </template>
          </el-calendar>
        </div>
        <div v-else>
          <el-empty description="暂无档案打卡记录"></el-empty>
        </div>
      </div>
      <span
        v-if="false"
        slot="footer"
        class="dialog-footer"
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <el-button type="danger" @click="changestatus(3, '删除')"
          >删除</el-button
        >
        <div>
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="success" @click="changestatus(1, '更换')"
            >更换机构
          </el-button>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      :title="selected.day + '日记录'"
      :visible.sync="dialogVisible1"
      width="50%"
      :before-close="handleClose"
    >
      <el-descriptions
        class="margin-top"
        :column="1"
        border
        v-if="selected.content"
      >
        <el-descriptions-item v-for="(p, i) in selected.content" :key="i">
          <template slot="label">
            {{ p.type }}
          </template>
          <div style="display: flex; justify-content: space-between">
            <div>{{ p.neirong }}</div>
            <div style="margin-right: 20px; color: green; font-weight: bold">
              完成情况:{{ p.score }}
            </div>
          </div>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 教师 </template>
          {{ selected.teacher }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 考勤情况 </template>
          {{ selected.isclock == true ? "人脸考勤" : "手动考勤" }}
        </el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog width="30%" :visible.sync="dialogVisible2" title="选择更换机构">
      <el-select filterable v-model="value" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button @click="cxzj" style="margin-left: 10px" type="primary"
        >确认更换</el-button
      >
    </el-dialog>
  </div>
</template>

<script>
function timeDifference(startTimeStr, endTimeStr) {
  // 确保时间字符串格式为 YYYY-MM-DDTHH:mm:ss
  //打印下
  const startTime = new Date(startTimeStr);
  const endTime = new Date(endTimeStr);
  if (isNaN(startTime.getTime()) || isNaN(endTime.getTime())) {
    throw new Error("Invalid date format");
  }

  const difference = endTime.getTime() - startTime.getTime();
  const hours = Math.floor(difference / (1000 * 60 * 60));
  const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((difference % (1000 * 60)) / 1000);
  return hours + "小时" + minutes + "分" + seconds;
}

function convertISOToNormal(isoString) {
  const date = new Date(isoString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // getMonth() returns 0-based index
  const day = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  // 构造正常时间格式字符串
  const normalFormat = `${hours}:${minutes}:${seconds}`;

  return normalFormat;
}

function shijiancha(start_time, end_time) {
  const startDate = new Date(start_time);
  const endDate = new Date(end_time);
  const timeDiff = endDate - startDate; // 毫秒差
  const hoursDiff = timeDiff / (1000 * 60 * 60); // 转换为小时
  return hoursDiff;
}
export default {
  data() {
    return {
      loading: false,
      ll: "",
      optionss: [],
      value: "",
      day_sum: 0,
      shichang_sum: 0,
      tanchuang: true,
      riLists: [],
      lists: [],
      total: 0,
      hosps: [],
      options: [],
      selectform: {
        idcard: "",
        name: "",
        hosp: "",
        qu_id: "",
        status: "",
      },
      allstatus: [],
      fullscreenLoading: false,
      page: 1,
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      detailflag: false,
      nian: new Date(),
      nianv1: "",
      biao: {},
      stu_type: null,
      isdang: false,
      stuid: 0,
      selected: {},
    };
  },
  computed: {
    teatoken() {
      return window.localStorage.getItem("tea_token");
    },
    info() {
      let info = window.localStorage.getItem("info");
      return JSON.parse(info);
    },
    org() {
      let org = window.localStorage.getItem("org");
      return JSON.parse(org);
    },
  },
  directives: {
    prevMonthBtn: {
      inserted(el, binding, vnode) {
        const vm = vnode.context; // 保存外部的this引用
        el.addEventListener("click", () => {
          const calendarComponent = vm.$refs.calendar;
          let bb = calendarComponent.selectedDay.slice(0, 7);
          let aa = calendarComponent.selectedDay.split("-")[0];
          if (aa != vm.nian) {
            vm.loading = true;
            vm.getdaylistv1(bb);
          }
        });
      },
    },
  },
  methods: {
    godangan(e) {
      let type = e.cjtypes;
      //console.log(type, "asdfawefasdfawe撒地方拉萨的飞机 ");
      if (
        type.includes("孤独症(精神") ||
        type.includes("智力") ||
        type.includes("精神")
      ) {
        let routeData = this.$router.resolve({
          name: "dangan",
          query: {
            stuid: e.id,
            year: e.nian,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type.includes("肢体")) {
        let routeData = this.$router.resolve({
          name: "dangan_zt",
          query: {
            stuid: e.stuid,
            nian: e.nian,
            org_id: this.stu_type.org_id,
            stu_type: this.stu_type.stu_disability,
            stu_name: e.name,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (
        type.includes("听力") ||
        type.includes("言语") ||
        type.includes("听力言语") ||
        type.includes("言语听力")
      ) {
        let routeData = this.$router.resolve({
          name: "dangan_tlyy",
          query: {
            stuid: this.stuid,
            nian: this.nian,
            org_id: this.stu_type.org_id,
            stu_type: this.stu_type.stu_disability,
            stu_name: this.stu_type.stu_name,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type.includes("视力")) {
        let routeData = this.$router.resolve({
          name: "dangan_shili",
          query: {
            stuid: this.stuid,
            nian: this.nian,
            org_id: this.stu_type.org_id,
            stu_type: this.stu_type.stu_disability,
            stu_name: this.stu_type.stu_name,
          },
        });
        window.open(routeData.href, "_blank");
      } else {
        let routeData = this.$router.resolve({
          name: "dangan",
          query: {
            stuid: this.stuid,
            year: this.nian,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
    get_kq_info(date) {
      let i = this.riLists.findIndex((x) => {
        return x.day == date.day;
      });
    },
    async cxzj() {
      let name = this.value;
      let idcard = this.selected.idcard;
      let admin = this.info.name;
      let qu_id = this.org.area;
      let nian = this.nian;
      let id = this.selected.id;
   //   console.log(this.selected, "------===============");
      this.dialogVisible2 = false;
      let ans = await axios.get(this.$url + "hospital/reset_hosp", {
        params: {
          token: this.info.uid,
          name,
          idcard,
          admin,
          qu_id,
          nian,
          id,
        },
      });
      this.getdata();
      this.$message({
        message: ans.data.desc,
        type: ans.data.status == 0 ? "success" : "error",
      });
    },
    async gethospss() {
      this.options = [];
      let res = await axios.get(this.$url + "hospital/kslists", {
        params: {
           token: this.info.uid,
           year: this.nian,
        },
      });
      res.data.msg.map((p) => {
        this.options.push({
          value: p.hname,
          label: p.hname,
        });
      });
    },
    //日记录数据请求
    async getdaylistv1(aa) {
      this.day_sum = 0;
      this.shichang_sum = 0;
      let res = await axios.get(this.$urls + "canlian/kstjcha", {
        params: {
          stu_id: this.stuid,
          day: aa,
        },
        headers: {
          teatoken: this.teatoken
        }
      });
      this.loading = false;
      let a = res.data.jj;
      if (a.length != 0) {
        this.riLists = [];
        for (let i = 0; i < a.length; i++) {
          this.riLists.push({
            day: a[i].riqi_ke,
            teacher: a[i].teacher_ke,
            type: a[i].dcs_class,
            riqi_bu: a[i].riqi_bu,
            riqi_ke: a[i].riqi_ke,
            bq_reason:
              a[i].bq_reason == null || a[i].bq_reason == "null"
                ? ""
                : a[i].bq_reason,
            riqi_lj_text:
              a[i].riqi_lj_text == null || a[i].riqi_lj_text == "null"
                ? ""
                : a[i].riqi_lj_text,
            isclock: true,
            content: this.content,
            time_star: convertISOToNormal(a[i].start_time),
            time_end: convertISOToNormal(a[i].end_time),
            time_sum: timeDifference(a[i].start_time, a[i].end_time),
          });
          this.day_sum += 1;
          this.shichang_sum += shijiancha(a[i].start_time, a[i].end_time);
          // console.log("963963");
          // if (a[i].dcs_class == "考勤机打卡") {
          // 	// console.log(a[i].dcs_class == "考勤机打卡");

          // } else {
          // 	this.riLists.push({
          // 		day: a[i].riqi_ke,
          // 		teacher: a[i].teacher_ke,
          // 		isclock: false,
          // 		content: this.content
          // 	})
          // }、
        }
       // console.log(a, "---------------");
      }
    },

    //日记录数据请求
    async getdaylist(rejt) {
      this.day_sum = 0;
      this.shichang_sum = 0;
      this.loading = true;
      var da = rejt
        ? this.nian.getFullYear()
        : this.nian.getFullYear() +
          "-" +
          (new Date().getMonth() + 1 < 10
            ? "0" + (new Date().getMonth() + 1)
            : new Date().getMonth() + 1);
     // console.log(da, "rejtrejtrejtrejtrejt");
      let res = await axios.get(this.$urls + "canlian/kstjcha", {
        params: {
          stu_id: this.stuid,
          day: da,
        },
        headers: {
          teatoken: this.teatoken
        }
      });
      this.loading = false;
      let a = res.data.jj;
      if (a.length != 0) {
        for (let i = 0; i < a.length; i++) {
          this.riLists.push({
            day: a[i].riqi_ke,
            teacher: a[i].teacher_ke,
            type: a[i].dcs_class,
            riqi_bu: a[i].riqi_bu,
            riqi_ke: a[i].riqi_ke,
            bq_reason:
              a[i].bq_reason == null || a[i].bq_reason == "null"
                ? ""
                : a[i].bq_reason,
            riqi_lj_text:
              a[i].riqi_lj_text == null || a[i].riqi_lj_text == "null"
                ? ""
                : a[i].riqi_lj_text,
            isclock: true,
            content: this.content,
            time_star: convertISOToNormal(a[i].start_time),
            time_end: convertISOToNormal(a[i].end_time),
            time_sum: timeDifference(a[i].start_time, a[i].end_time),
          });
          this.day_sum += 1;
          this.shichang_sum += shijiancha(a[i].start_time, a[i].end_time);
        }
        this.关闭加载;
        //console.log(this.riLists, "999999999999999999999999999");
      }
    },

    //点击日历执行的事件
    async djday(date, data) {
      //console.log(date);
      //console.log(data);
      this.tanchuang = true;
      // console.log(data.day.substring(0, 7), '223333');
      let res = await axios.get(this.$urls + "canlian/rjlcha", {
        params: {
          stu_id: this.stu_id,
          day: data.day,
        },
      });
      if (res.data.length != 0) {
        for (let i in res.data) {
          this.content.push({
            type: res.data[i].Area_Name,
            neirong: res.data[i].content,
            score: res.data[i].Completion,
          });
        }
        // console.log(this.riLists, "this.riLists6666666666666");
        this.tanchuang = false;
      } else {
        this.open();
        this.tanchuang = false;
      }
      let a = this.riLists.find((x) => {
        return x.day == data.day;
      });
      if (a) {
        this.dialogVisible1 = true;
        this.selected = a;
        this.content = [];
      } else {
        this.open2();
      }
    },

    //提醒弹窗'该日还未填入数据'
    open() {
      this.$alert("该日还未填入数据", {
        confirmButtonText: "确定",
        callback: (action) => {
          // this.$message({
          //   type: 'info',
          //   message: `action: ${ action }`
          // });
        },
      });
    },

    //提醒弹窗2'该日并没有考勤'
    open2() {
      this.$alert("该日并没有考勤", {
        confirmButtonText: "确定",
        callback: (action) => {
          // this.$message({
          //   type: 'info',
          //   message: `action: ${ action }`
          // });
        },
      });
    },
    opdangkq() {
      let routeData = this.$router.resolve({
        name: "onestukq",
        query: {
          stu_id: this.stuid,
          year: new Date().getFullYear()
        },
      });
      window.open(routeData.href, "_blank");
    },
    opdang() {
      let type = this.stu_type.stu_disability.split(",");
     // console.log(type, "asdfawefasdfawe撒地方拉萨的飞机 ");
      if (type.includes("孤独症(精神)") || type.includes("智力")) {
        let routeData = this.$router.resolve({
          name: "dangan",
          query: {
            stuid: this.stuid,
            year: this.nian,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type.includes("肢体")) {
        let routeData = this.$router.resolve({
          name: "dangan_zt",
          query: {
            stuid: this.stuid,
            nian: this.nian,
            org_id: this.stu_type.org_id,
            stu_type: this.stu_type.stu_disability,
            stu_name: this.stu_type.stu_name,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (
        type.includes("听力") ||
        type.includes("言语") ||
        type.includes("听力言语") ||
        type.includes("言语听力")
      ) {
        let routeData = this.$router.resolve({
          name: "dangan_tlyy",
          query: {
            stuid: this.stuid,
            nian: this.nian,
            org_id: this.stu_type.org_id,
            stu_type: this.stu_type.stu_disability,
            stu_name: this.stu_type.stu_name,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type.includes("视力")) {
        let routeData = this.$router.resolve({
          name: "dangan_shili",
          query: {
            stuid: this.stuid,
            nian: this.nian,
            org_id: this.stu_type.org_id,
            stu_type: this.stu_type.stu_disability,
            stu_name: this.stu_type.stu_name,
          },
        });
        window.open(routeData.href, "_blank");
      } else {
        let routeData = this.$router.resolve({
          name: "dangan",
          query: {
            stuid: this.stuid,
            year: this.nian,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
    async showdetail(row) {
      this.tanchuang = true;
      let row1 = JSON.parse(JSON.stringify(row));
      row1.ins_date = new Date(row1.ins_date).toLocaleString();
      row1.xianju_json = JSON.parse(row1.xianju_json);
      row1.huji_json = JSON.parse(row1.huji_json);
      if (
        row1.yixuezhengming == null ||
        row1.yixuezhengming == "" ||
        row1.yixuezhengming == undefined
      ) {
        row1.yixuezhengming = [];
      } else {
        row1.yixuezhengming = JSON.parse(row1.yixuezhengming);
      }
      this.biao = row1;
      let ans = await axios.get(this.$urls + "canlian/xsjbzlchav3", {
        params: {
          stu_sfz: row1.idcard,
          year: this.nian,
        },headers: {
          teatoken: this.teatoken
        }
      });
      //console.log(ans.data);
      this.detailflag = true;
      if (ans.data.status == 1) {
        this.isdang = true;
        this.nianv1 = this.nian;
        try {
          this.stuid = ans.data.stu_id[0].id;
          this.stu_type = ans.data.stu_id[0];
          this.riLists = [];
          this.tanchuang = false;
          await this.getdaylist();
        } catch (e) {}
      } else {
        this.isdang = false;
        this.stuid = 0;
      }
    },
    test(a, b, c) {
     // console.log(a);
      //console.log(b);
      //console.log(c);
    },
    async changestatus(row, status, tx) {
      let inputValue = status == -1 ? "该儿童经核实已不在训" : "该儿童已被移除";
      if (status == 0) {
        this.selected = row;
        return (this.dialogVisible2 = true);
      }
      let ans = await this.$prompt(
        `请输入${tx}意见`,
        `确实要${tx}${row.name}吗?`,
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputValue,
          type: "warning",
        }
      ).catch(() => {
        //row.guidang = false;
      });

      let y = await axios.get(this.$url + "hospital/change_asd_kf_info", {
        params: {
          token:this.info.uid,
          err_msg: ans.value,
          status: status,
          idcard: row.idcard,
          name: row.name,
          qu_id: this.org.area,
          admin: this.info.name,
          id: row.id,
        },
      });
      y.data.lists.map((item) => {
        item.huji_json = this.$sm2.jmSM2(item.huji_json);
        item.idcard = this.$sm2.jmSM2(item.idcard);
        item.jh_idcard = this.$sm2.jmSM2(item.jh_idcard);
        item.jigou_code = this.$sm2.jmSM2(item.jigou_code);
        item.phone = this.$sm2.jmSM2(item.phone);
        item.xianju_json = this.$sm2.jmSM2(item.xianju_json);
        item.yhcard = this.$sm2.jmSM2(item.yhcard);
      });
      this.$message({
        type: "success",
        message: `${tx}成功!`,
      });
      this.getdata();
    },
    handleClose(done) {
      this.dialogVisible = false;
      this.dialogVisible1 = false;
      this.detailflag = false;
    },
    async clear() {
      this.fullscreenLoading = true;
      this.selectform.name = "";
      this.selectform.hosp = "";
      this.selectform.status = "";
      this.selectform.qu_id = "";
      let where = {};
      if (this.selectform.name != "") {
        where.name = this.selectform.name;
      }
      if (this.nian != "") {
        let date = new Date(this.nian);
        where.nian = date.getFullYear();
      }
      if (this.org.area != "371100000000") {
        where.qu_id = this.org.area;
      }
      if (this.selectform.qu_id != "") {
        where.qu_id = this.selectform.qu_id;
        console.log(where.qu_id, "这个是我想看到的");
      }
      if (this.selectform.hosp != "") {
        where.hosp = this.selectform.hosp;
      }
      if (this.selectform.status != "") {
        where.status = this.selectform.status;
      }
      let ans = await axios.get(this.$url + "admin/asd_kf_info_alExcel", {
        params: {
         // token:this.info.uid,
          condition: JSON.stringify(where) == "{}" ? false : true,
          where: where,
          cl: this.org.name,
          token: JSON.parse(window.localStorage.getItem("info")).uid,
        },
      });

      // let ans = await axios.get(this.$urls + 'test/asd_kf_info_alExcel', {
      //   params: {
      //     condition: JSON.stringify(where) == "{}" ? false : true,
      //     where: where,
      //     cl:this.org.name,
      //     token:JSON.parse(window.localStorage.getItem("info")).uid
      //   }
      // })
      if (ans) {
        setTimeout(() => {
          this.fullscreenLoading = false;
        }, 500);
        if (ans.data.status == 1) {
          this.$alert("密码是:"+ans.data.password+"  跳转页面Ctrl+S下载保存", {
            confirmButtonText: "跳转",
            callback: (action) => {
              window.open(this.$url + ans.data.path, "_blank");
            },
          });
        } else {
          this.$alert("网络波动，失败", {
            confirmButtonText: "确定",
            callback: (action) => {},
          });
        }
      }
    },
    async getallstatus() {
      let ans = await axios.get(this.$url + "hospital/asd_kf_status", {
        params: {
          token:this.info.uid,
        },
      });
      this.allstatus = ans.data;
    },

    async gethospsss() {
      let y = await axios.get(this.$url + "onething/area");
      this.optionss = y.data.lists;
    },
    async gethosps() {
      let nian = null;
      if (this.nian != "") {
        let date = new Date(this.nian);
        nian = date.getFullYear();
      }
      let ans = await axios.get(this.$url + "hospital/asd_kf_hosps", {
        params: {
          token:this.info.uid,
          qu_id: this.org.area,
          nian: nian,
        },
      });
      this.hosps=[];
      ans.data.lists.map(async (p) => {
        this.hosps.push({
          value: p.hosp,
          label: p.hosp + `(${p.ob})`,
        });
      });
    },
    async getdata() {
      let where = {};
      if (this.selectform.name != "") {
        where.name = this.selectform.name;
      }
      if (this.selectform.idcard != "") {
        where.idcard = this.selectform.idcard;
      }
      if (this.nian != "") {
        let date = new Date(this.nian);
        where.nian = date.getFullYear();
      }
      if (this.org.area != "371100000000") {
        where.qu_id = this.org.area;
      }
      if (this.selectform.hosp != "") {
        where.hosp = this.selectform.hosp;
      }
      if (this.selectform.qu_id != "") {
        where.qu_id = this.selectform.qu_id;
      }
      if (this.selectform.status != "") {
        where.status = this.selectform.status;
      }
      let ans = await axios.get(this.$url + "hospital/asd_kf_info", {
        params: {
          token:this.info.uid,
          condition: JSON.stringify(where) == "{}" ? false : true,
          page: this.page - 1,
          where: where
        },
      });
     // console.log(ans, "这是我想要的看到的");
      ans.data.lists.map((item) => {
        item.huji_json = this.$sm2.jmSM2(item.huji_json);
        item.idcard = this.$sm2.jmSM2(item.idcard);
        item.jh_idcard = this.$sm2.jmSM2(item.jh_idcard);
        item.jigou_code = this.$sm2.jmSM2(item.jigou_code);
        item.phone = this.$sm2.jmSM2(item.phone);
        item.xianju_json = this.$sm2.jmSM2(item.xianju_json);
        item.yhcard = this.$sm2.jmSM2(item.yhcard);
      });
      this.lists = ans.data.lists;
      ans.data.lists.map((p) => {
        try {
          p.cjtypes = JSON.parse(p.cjtypes);
        } catch (e) {
          p.cjtypes = [p.cjtypes];
        }

        p.status = this.allstatus.find((x) => {
          return x.value == p.status;
        });
      });
      this.total = ans.data.count;
    },
  },
  watch: {
    nian() {
      this.nianv1 = this.nian;
      this.gethosps()
    },
  },
  async created() {
    this.nianv1 = this.nian;
    this.gethosps();
    this.gethospss();
    this.gethospsss();
    await this.getallstatus();
    await this.getdata();
  },
};
</script>

<style>
.margin-top {
  margin-top: 20px;
  margin-bottom: 20px;
}

.calendar-page-calendar__header-btn {
  display: none;
}

/* 隐藏左边显示的日期 */
.calendar-page-calendar__sidebar {
  display: none;
}

/* .el-calendar__title {
    	color: #000;
    	align-self: center;
    	display: none;
	} */
</style>